import React, { Component } from 'react';
import './OviewMap.css'

const Geo3DPoint = window.Geo3DPoint;
export default class OviewMap extends Component {   
    constructor(props) {
        super(props);

        this.initBaseLayerParam = {
            url: "https://wmts.nlsc.gov.tw/wmts",
            identifier: "EMAP",
            urlTemplate: "{URL}"
        }
    }

    componentDidMount() {
        //開啟oview圖台
        window.gMainMap.Init("MainMap", this.openTerrainCallback.bind(this));
    }

    async openTerrainCallback() {
        //window.gMainMap.layerManager = new LayerManager(window.gMainMap.TerrainView)
        window.gMainMap.TerrainView.setBaseLayer(this.initBaseLayerParam);
        //設定初始位置
        let initialPos = new window.GeoPoint(
            120.6925705503777, 23.90282702330336, 264.3642244036524
        );
        let initialUp = new Geo3DPoint(-0.5480174933105086, 0.01615513463532407, 0.8363108504919576);
        let initialV = new Geo3DPoint(-0.8359477403630035, 0.024641867384041033, -0.5482555551508946);
        let initialCamera = new window.ov.Camera(initialPos, initialV, initialUp);
        window.gMainMap.TerrainView.gotoCamera(initialCamera, false);

        //關閉控制面板
        //window.gMainMap.TerrainView.controlPanel = false;
        //穿過地表
        window.gMainMap.TerrainView.throughSurface = true;
        //用來記錄圖層開啟狀態(每次開啟都會push圖層名進來)
        window.gMainMap.TerrainView.openedLayerStack = [];
    }

    render() {
        return (
            <div id="MainMap" className="map">
            </div>
        );
    }
}